const convertTransactionAmount = (transactionAmount) => {
    return transactionAmount/100;
};

export const TransactionAmountService = {
    convertTransactionAmount
};